<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <div class="pa-4">
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" :hide-details="true" />
        </div>

        <div class="mb-4">
          <label class="label-input">Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <label>Background Section</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['styleSection']['background']"
                    @change="event => (fields['styleSection']['background'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['styleSection']['background']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['styleSection']['textColor']"
                    @change="event => (fields['styleSection']['textColor'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['styleSection']['textColor']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Background Card</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['bg-card']"
                    @change="event => (fields['bg-card'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['bg-card']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Media Position</label>
                <v-select
                  :value="fields['card-right-order']"
                  :items="positionOptions"
                  :hide-details="true"
                  class="mt-0"
                  @change="handleChangeMediaPosition"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields['styleSection']['topPadding']"
                  label="Top Padding"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields['styleSection']['bottomPadding']"
                  label="Bottom Padding"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields['containerPage']['enableStyle']"
                  label="Enable Style Container"
                  :hide-details="true"
                />
                <div v-if="fields['containerPage']['enableStyle']">
                  <v-row>
                    <v-col cols="12" md="6">
                      <label>Background Color</label>
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          :value="fields['containerPage']['background']"
                          @change="event => (fields['containerPage']['background'] = event.target.value)"
                        />
                        <v-text-field
                          v-model="fields['containerPage']['background']"
                          :hide-details="true"
                          class="mt-0"
                        />
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <label>Text Color</label>
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          :value="fields['containerPage']['textColor']"
                          @change="event => (fields['containerPage']['textColor'] = event.target.value)"
                        />
                        <v-text-field
                          v-model="fields['containerPage']['textColor']"
                          :hide-details="true"
                          class="mt-0"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Card Title</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields['card-title']" :config="editorConfig" />
          </div>
        </div>

        <div>
          <div class="label-input">Tags</div>
          <div class="group-item">
            <div>
              <v-row>
                <v-col cols="12" md="6">
                  <label>Text Color</label>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['color-tag-item']"
                      @change="event => handleChangeColor(event, 'color-tag-item')"
                    />
                    <v-text-field v-model="fields['color-tag-item']" :hide-details="true" class="mt-0" />
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <label>Background Color</label>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['bg-tag-item']"
                      @change="event => handleChangeColor(event, 'bg-tag-item')"
                    />
                    <v-text-field v-model="fields['bg-tag-item']" :hide-details="true" class="mt-0" />
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <label>Hover Text Color</label>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['color-hover-tag-item']"
                      @change="event => handleChangeColor(event, 'color-hover-tag-item')"
                    />
                    <v-text-field v-model="fields['color-hover-tag-item']" :hide-details="true" class="mt-0" />
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <label>Hover Background Color</label>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['bg-hover-tag-item']"
                      @change="event => handleChangeColor(event, 'bg-hover-tag-item')"
                    />
                    <v-text-field v-model="fields['bg-hover-tag-item']" :hide-details="true" class="mt-0" />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="mb-4">
              <div class="d-flex justify-space-between align-center mb-2">
                <label class="label-input mb-0"></label>
                <v-btn small color="primary" @click="handleAddTag">Add Tag</v-btn>
              </div>
              <v-expansion-panels accordion>
                <v-expansion-panel v-for="(tag, index) in fields.tags" :key="`tag-${index}`">
                  <v-expansion-panel-header>
                    <div class="d-flex justify-space-between align-center">
                      <span>{{ tag.text }}</span>
                      <v-btn small icon @click.stop="handleRemoveTag(index)">
                        <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="mb-3">
                      <label>Text</label>
                      <v-text-field v-model="tag.text" :hide-details="true" />
                    </div>
                    <div class="mb-3">
                      <label>Link</label>
                      <v-text-field v-model="tag.link" :hide-details="true" />
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Card Right Media</label>
          <div class="group-item">
            <v-radio-group small row dense :value="fields.media.type" @change="handleChangeMediaType">
              <v-radio small label="Video" value="video" />
              <v-radio small label="Image" value="image" />
            </v-radio-group>

            <div v-if="fields.media.type === 'video'">
              <label>Video URL</label>
              <div class="d-flex align-center gap-6 mb-2">
                <v-text-field v-model="fields.media.video" :hide-details="true" class="mt-0" />
                <v-btn @click="handlePreviewVideo" text color="primary"> <v-icon>mdi-reload</v-icon> Reload </v-btn>
              </div>
              <div class="video-wrapper">
                <div class="wrap-video">
                  <video width="100%" height="auto" autoplay muted loop playsinline ref="videoPlayer">
                    <source type="video/mp4" :src="fields.media.video" />
                  </video>
                </div>
              </div>
            </div>

            <div v-if="fields.media.type === 'image'">
              <UploadImage
                @callback="handleUploadImage"
                :image="{ imageSrc: fields.media.image }"
                :height="`220`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveUpload"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '../common/form/upload-file/upload-image.vue';
import { updateHtmlFromData } from '../common/html/update';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';

const defaultFields = () => ({
  title: 'Card Hsia Tags Section',
  'bg-card': '#f5f1ee',
  'card-left-order': 1,
  'card-right-order': 2,
  'card-title': 'Every Curve Deserves Comfort',
  'color-tag-item': '#ffffff',
  'bg-tag-item': '#000000',
  'color-hover-tag-item': '#000000',
  'bg-hover-tag-item': '#ffffff',
  tags: [
    { text: 'B CUP', link: '#' },
    { text: 'D CUP', link: '#' },
    { text: 'E CUP', link: '#' },
  ],
  styleSection: {
    topPadding: false,
    bottomPadding: false,
    background: '#FFFFFF',
    textColor: '#000000',
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  media: {
    type: 'video',
    video: '',
    image: '',
  },
});

export default {
  name: 'CardHsiaTags',
  components: {
    UploadImage,
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      positionOptions: [
        { text: 'Right', value: 2 },
        { text: 'Left', value: 1 },
      ],
      fields: defaultFields(),
    };
  },

  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    const extracted = this.sectionEditor.sectionExtract || {};
    const fallback = defaultFields();
    this.fields = {
      ...fallback,
      ...extracted,
      media: {
        ...fallback.media,
        ...(extracted.media || {}),
      },
      styleSection: {
        ...fallback.styleSection,
        ...(extracted.styleSection || {}),
      },
      containerPage: {
        ...fallback.containerPage,
        ...(extracted.containerPage || {}),
      },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        media: {
          ...this.fields.media,
          type: this.fields.media.type === 'image' ? 'image' : 'video',
        },
      };
      const updateHtml = updateHtmlFromData.sectionCardHsiaTags(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: payload.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handlePreviewVideo() {
      const video = this.$refs.videoPlayer;
      if (!video) return;
      video.load();
      video.play();
    },
    handleChangeBgCard(event) {
      this.fields['bg-card'] = event.target.value;
    },
    handleChangeColor(event, key) {
      this.fields[key] = event.target.value;
    },
    handleChangeMediaPosition(value) {
      const rightOrder = Number(value) === 1 ? 1 : 2;
      this.fields['card-right-order'] = rightOrder;
      this.fields['card-left-order'] = rightOrder === 1 ? 2 : 1;
    },
    handleChangeMediaType(type) {
      this.fields.media.type = type === 'image' ? 'image' : 'video';
    },
    handleAddTag() {
      this.fields.tags.push({ text: 'NEW TAG', link: '#' });
    },
    handleRemoveTag(index) {
      if (this.fields.tags.length <= 1) return;
      this.fields.tags.splice(index, 1);
    },
    handleUploadImage(obj) {
      this.fields.media.image = obj.imageSrc || '';
    },
    handleRemoveUpload() {
      this.fields.media.image = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 5px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  border: 1px solid #0000000f;
  border-radius: 8px;
  padding: 16px 12px;
  margin-bottom: 10px;
}
.video-wrapper {
  background: rgba(0, 0, 0, 0.767);
  .wrap-video {
    max-width: 500px;
    margin: 0 auto;
    video {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
